import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { useTimeout } from '../hooks';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { theme } from '../theme';
export const SnackbarItem = ({ autoCloseTime = 4, id, message, leadingIcon, canManuallyClose, showCloseIcon, deleteSnack, }) => {
    useTimeout(() => deleteSnack(id), autoCloseTime * 1000);
    return (React.createElement(SnackItem, { p: "16px", key: id, mt: "16px", flex: true, justifyContent: "space-between" },
        React.createElement(Box, { flex: true, alignItems: "center" },
            leadingIcon && (React.createElement(Icon, { mr: "12px", render: leadingIcon, size: 24, color: "mascarpone" })),
            React.createElement(Text, { typo: "body-small", color: "mascarpone" }, message)),
        canManuallyClose && (React.createElement(CloseButton, { onClick: () => deleteSnack(id), "aria-label": `close snackbar ${message}` }, showCloseIcon ? (React.createElement(Icon, { render: "cross", size: 16, color: "mascarpone" })) : (React.createElement(UnderlinedText, { tag: "span", typo: "headline-small", color: "mascarpone" }, "Dismiss"))))));
};
const SnackItem = styled(Box) `
  border-radius: 16px;
  background-color: ${theme.colors.liquorice};
`;
const CloseButton = styled.button `
  cursor: pointer;
`;
const UnderlinedText = styled(Text) `
  text-decoration: underline;
`;
//# sourceMappingURL=SnackbarItem.js.map